import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_CHA001_Request,
  IAPI_CHA001_Response,
  IAPI_CHA002_Request,
  IAPI_CHA002_Response,
  IAPI_CON001_Request,
  IAPI_CON001_Response,
} from "../../../type/apiType";

// スレッド一覧参照API
// API仕様書_チャット
const httpAPI_CHA001 = async (
  param: IAPI_CHA001_Request
): Promise<IAPI_CHA001_Response> => {
  let res = await http.post(ApiUrl.API_CHA001, {
    ...param,
  });

  return res.data;
};

// スレッド更新API
// API仕様書
const httpAPI_CHA002 = async (
  param: IAPI_CHA002_Request
): Promise<IAPI_CHA002_Response> => {
  let res = await http.post(ApiUrl.API_CHA002, {
    ...param,
  });

  return res.data;
};

// 契約者一覧参照API
// API仕様書_契約者
const httpAPI_CON001 = async (
  param: IAPI_CON001_Request
): Promise<IAPI_CON001_Response> => {
  let res = await http.post(ApiUrl.API_CON001, {
    ...param,
  });

  return res.data;
};
export { httpAPI_CHA001, httpAPI_CON001, httpAPI_CHA002 };
